import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {LoggingService} from 'mclane-apptemplate-lib';
import {JwtService} from 'mclane-webauth-lib';

@Injectable()
export class AuthGuardService  {
  constructor(private _keycloakService: KeycloakService, public router: Router, private _jwtService: JwtService,
              public console: LoggingService) {
  }

  canActivate(): boolean {
    if (!this._keycloakService.isLoggedIn()) {
      this.router.navigate(['']).then(() => {
      });
      return false;
    }
    this._keycloakService.getToken().then(async (token) => {
      this._jwtService.setJwt(token);
    });
    return true;
  }
}
